import { ref } from "vue";
import { defineStore } from "pinia";
import ApiService from "@/core/services/ApiService";
import { SystemInitDto, UserWithSimpleInfoDto, ZoneWithSimpleInfoDto } from "../core/services/ApiClient";

export const useSystemStore = defineStore("system", () => {
    const systemData = ref<SystemInitDto>();
    const users = ref<UserWithSimpleInfoDto[]>([]);
    const zones = ref<ZoneWithSimpleInfoDto[]>([]);
    const newsCount = ref<null>();
    const isInited = ref(false);
    async function init() {
        const response =await ApiService.apiClient.initSystem()
        if (response.data) {
            isInited.value = true
            systemData.value = response.data;
            users.value = response.data.users || [];
            zones.value = response.data.zones || [];
        }
    }

 function newsGetCount() {
     ApiService.apiClient.newsGetCount().then((response) => {
        if (response.data) {
            newsCount.value = response.data;
            console.log("response", newsCount.value)
       
         }
     });
    }

    return {
        isInited,
        systemData,
        users,
        zones,
        init,
        newsCount,
        newsGetCount
    };
});
